module.exports = __webpack_public_path__ + "static/media/logo-or-avner.dc5c8811.webp";